// الحقول المرتبطة في ردود المالية (الفئة، القاصة، مُنفّذ العملية) تعود مربوطة
// ككائن: { _id, name } للقاصة و { _id, username, fullName } للمستخدم. أما في
// الردود غير المربوطة فتعود معرّفاً نصّياً. هذه الدوال تقرأ الحالتين بلا كسر.

const DASH = '—';

/** كائن المرجع إن كان مربوطاً، أو كائن فارغ إن كان معرّفاً فقط. */
export function refObject(value) {
  if (!value || typeof value === 'string') return {};
  return value;
}

/** اسم المرجع (قاصة/فئة) أو الشرطة. */
export function refName(value, fallback = DASH) {
  const name = refObject(value).name;
  return name && String(name).trim() ? name : fallback;
}

/** اسم المستخدم المعروض: الاسم الكامل وإلا اسم الدخول. */
export function userName(value, fallback = DASH) {
  const user = refObject(value);
  const name = user.fullName || user.username;
  return name && String(name).trim() ? name : fallback;
}

/** معرّف المرجع سواء جاء مربوطاً أو نصّاً. */
export function refId(value) {
  if (!value) return null;
  if (typeof value === 'string') return value;
  return value._id || value.id || null;
}
